import React from 'react';
import { LeftTrayItem, ScrollMenuItem } from '../../components/elements';
import { ISurvey } from '../../components/Surveys/Interfaces/ISurvey';
import { ISurveyTemplateElementGroupData } from '../../components/Surveys/ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from '../../components/Surveys/ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from '../../components/Surveys/ISurveyTemplateUnitData';
import { fetchJson } from '../../store/fetch';
import { ICustomInspectionTypeFrontEndSettings } from '../ICustomInspectionTypeFrontEndSettings';
import { SurveyDetailsVerificatieBerekeningReport } from './SurveyDetailsVerificatieBerekeningReport';
import { SurveyDetailsVerificatieBerekeningSummaryAndAdvice } from './SurveyDetailsVerificatieBerekeningSummaryAndAdvice';
import { SurveyEditVerificatieBerekeningAnalysis } from './SurveyEditVerificatieBerekeningAnalysis';
import { SurveyEditVerificatieBerekeningSummaryAndAdvice } from './SurveyEditVerificatieBerekeningSummaryAndAdvice';
import { VerificatieBerekeningScoreLabel } from './VerificatieBerekeningScoreLabel';

const tabNames = {
    analysis: 'analysis',
    download: 'download',
    summaryAndAdvice: 'summaryAndAdvice',
};

function SurveyEditPage(
    props: { tabName: string; surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & (
        | ISurveyTemplateUnitData
        | ISurveyTemplateElementGroupData
        | ISurveyTemplateManifestationData
    ),
) {
    switch (props.tabName) {
        case tabNames.analysis: {
            return <SurveyEditVerificatieBerekeningAnalysis {...props} />;
        }
        case tabNames.download:
        case tabNames.summaryAndAdvice:
            return null;
        default:
            return <h1>Unknown tab &quot;${props.tabName}&quot;</h1>;
    }
}
function SurveyDetailsLeftTrayListItems(props: { survey: ISurvey }) {
    return (
        <LeftTrayItem title="Resultaat">
            <VerificatieBerekeningScoreLabel score={props.survey.condition} />
        </LeftTrayItem>
    );
}
function SurveyDetailsScrollMenuItems(props: { scrollTo: (name: string) => void }) {
    return (
        <>
            <ScrollMenuItem text="Samenvatting en advies" icon="fa fa-file-text-o" onClick={() => props.scrollTo('SummaryAndAdvice')} />
            <ScrollMenuItem text="Rapport" icon="fa fa-tasks" onClick={() => props.scrollTo('VerificatieBerekeningRapport')} />
        </>
    );
}

function SurveyDetailsComponents(props: { survey: Required<ISurvey> }) {
    return (
        <>
            <SurveyDetailsVerificatieBerekeningSummaryAndAdvice survey={props.survey} />
            <SurveyDetailsVerificatieBerekeningReport surveyId={props.survey.id} />
        </>
    );
}

function SurveyEditSummaryAndAdvice(props: { surveyId: string }) {
    return <SurveyEditVerificatieBerekeningSummaryAndAdvice surveyId={props.surveyId} />;
}

function ConditionLabel(props: { conditionScore?: string }) {
    return <VerificatieBerekeningScoreLabel score={props.conditionScore} />;
}

export const verificatieBerekeningFrontEndSettings: ICustomInspectionTypeFrontEndSettings = {
    tabNames,

    surveyEditTabs: [
        { name: tabNames.analysis, textTranslateKey: 'failureMode.analysis' },
        { name: tabNames.download, textTranslateKey: 'survey.downloads' },
        { name: tabNames.summaryAndAdvice, textTranslateKey: 'survey.summaryAndAdviceTab' },
    ],

    surveyEditDefaultTabName: tabNames.analysis,
    showDocuments: true,

    objectTreeOptions: {
        hasElementsGroups: true,
        archiveLinkAvailable: false,
    },

    objectTreeDefaults: {
        filterOnElementGroups: true,
    },

    surveyEditLoadElements: async (surveyId: string) => {
        const elementsResponse = await fetchJson(`/api/surveys/${surveyId}/elements/verificatieBerekening/objectTree`, 'GET');
        const elements = elementsResponse.json;
        const elementGroupsResponse = await fetchJson(`/api/surveys/${surveyId}/elementGroups/verificatieBerekening/objectTree`, 'GET');
        const elementGroups = elementGroupsResponse.json;
        return {
            elements,
            elementGroups,
        };
    },

    showObjectTree: (tabName: string) => tabName === tabNames.analysis,

    getSurveyEditPage: SurveyEditPage,
    getSurveyDetailsLeftTrayListItems: SurveyDetailsLeftTrayListItems,
    getSurveyDetailsScrollMenuItems: SurveyDetailsScrollMenuItems,
    getSurveyDetailsComponents: SurveyDetailsComponents,
    getSurveyEditSummaryAndAdvice: SurveyEditSummaryAndAdvice,
    getConditionLabel: ConditionLabel,
};
